import { Dictionary } from '../common';
import { IconResponse, IIcon } from './Icon.interface';

export class IconModel implements IIcon {
  id: number;
  title: string;
  src: string;
  is_active?: boolean;
  is_favorite?: boolean;
  created_at?: Date;
  updated_at?: Date;

  constructor(data: IconResponse) {
    this.id = data.id || 0;
    this.title = data.title || '';
    this.src = data.src || '';
    this.is_active = data.is_active === 1 ? true : false;
    this.is_favorite = data.is_favorite === 1 ? true : false;
    this.created_at = data.created_at ? new Date(data.created_at) : new Date();
    this.updated_at = data.updated_at ? new Date(data.updated_at) : new Date();
  }
}

export type Icons = Dictionary<IconModel>;
